var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg061AddUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 22C3.55228 22 4 21.5523 4 21C4 16.5817 7.58172 13 12 13C13.9144 12.8942 15.7998 13.5037 17.29 14.71C17.5437 14.9637 17.9134 15.0627 18.2599 14.9699C18.6064 14.877 18.877 14.6064 18.9699 14.2599C19.0627 13.9134 18.9637 13.5437 18.71 13.29C17.8187 12.523 16.7811 11.9447 15.66 11.59C17.3712 10.0638 17.9561 7.6361 17.1276 5.49807C16.2991 3.36004 14.2311 1.96032 11.9383 1.98569C9.64549 2.01106 7.60899 3.45619 6.828 5.61203C6.04702 7.76787 6.68543 10.182 8.43 11.67C4.56147 13.1485 2.00457 16.8586 2 21C2 21.5523 2.44772 22 3 22ZM12 4C13.933 4 15.5 5.567 15.5 7.5C15.5 9.43299 13.933 11 12 11C10.067 11 8.5 9.43299 8.5 7.5C8.5 5.567 10.067 4 12 4ZM20 21C20 21.5523 19.5523 22 19 22C18.4477 22 18 21.5523 18 21V20H17C16.4477 20 16 19.5523 16 19C16 18.4477 16.4477 18 17 18H18V17C18 16.4477 18.4477 16 19 16C19.5523 16 20 16.4477 20 17V18H21C21.5523 18 22 18.4477 22 19C22 19.5523 21.5523 20 21 20H20V21Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg061AddUser);
export default __webpack_public_path__ + "static/media/061-add-user.f01d6ec40c66d4540e1fad56951062d9.svg";
export { ForwardRef as ReactComponent };